export interface MemberPortalMembership {
  level: string
  status: string
  member_number: number | null
  member_since_on: string | null
  renewal_due_on: string | null
  member_self_cancellation_enabled?: boolean
  scheduled_cancellation_end_on?: string | null
  application_submitted_on?: string | null
  yearly_price: string
  yearly_price_label?: string
  yearly_price_cents: number
  level_change_targets?: Array<{
    id: number
    name: string
    description: string | null
    price: string
    price_label?: string
    price_cents: number
  }>
  renewal_state?:
    | { kind: 'scheduled'; arrival_on: string }
    | {
        kind: 'open_invoice'
        invoice_id: number
        invoice_number: number
        amount: string
        amount_cents: number
        invoice_path: string
      }
    | null
  autopay: {
    enrolled: boolean
    brand: string | null
    last4: string | null
    next_charge_on: string | null
  }
}

export interface MemberStatusSource {
  kind: 'membership' | 'organization_roster'
  label: string
  level: string
  status: string
  renews_on: string | null
  term_starts_on?: string | null
  price: string | null
  organization_id?: number
  roster_place_id?: number
  added_by?: string | null
  added_on?: string | null
}

import { displayLongDate } from '@/lib/dates'

export const displayPortalDate = displayLongDate

export function membershipBadgeVariant(scheduledEndOn: string | null, status: string) {
  return scheduledEndOn || status !== 'Active' ? 'neutral' : 'success'
}

export function canDeclareCancellation(membership: MemberPortalMembership) {
  return (
    membership.member_self_cancellation_enabled &&
    ['Active', 'Pending-Renewal'].includes(membership.status)
  )
}
